/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { DeploymentDto } from './deploymentDto';
import { RequestedShare } from './requestedShare';


export interface AnimalDto { 
    id?: number;
    label?: string;
    role?: AnimalDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    colorRgbCode?: string;
    animalSex?: AnimalDto.AnimalSexEnum;
    creationTimestamp?: string;
    updateTimestamp?: string;
    deployments?: Array<DeploymentDto>;
    dateOfBirth?: string;
    dateOfDeath?: string;
    deathComment?: string;
    animalSpeciesId?: string;
    accessOnlyFromCollar?: boolean;
}
export namespace AnimalDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
    export const AnimalSexEnum = {
        Male: 'MALE',
        Female: 'FEMALE',
        Unknown: 'UNKNOWN'
    } as const;
    export type AnimalSexEnum = typeof AnimalSexEnum[keyof typeof AnimalSexEnum];
}


export type RoleEnum = typeof AnimalDto.RoleEnum[keyof typeof AnimalDto.RoleEnum];
export type AnimalSexEnum = typeof AnimalDto.AnimalSexEnum[keyof typeof AnimalDto.AnimalSexEnum];
